"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOADING_RESULT = exports.createLoadingResult = exports.createDataResult = exports.createErrorResult = void 0;
const createErrorResult = (error) => ({
    error,
    data: undefined,
    loaded: true,
    createdAt: Date.now(),
});
exports.createErrorResult = createErrorResult;
const createDataResult = (data) => ({
    data,
    loaded: true,
    createdAt: Date.now(),
});
exports.createDataResult = createDataResult;
const createLoadingResult = () => ({
    error: undefined,
    loaded: false,
    createdAt: Date.now(),
});
exports.createLoadingResult = createLoadingResult;
exports.LOADING_RESULT = {
    loaded: false,
};
//# sourceMappingURL=result.js.map